import { motion } from 'framer-motion';
import { useRouter } from 'next/router';
import React from 'react';
import { LinkWithQuery } from '@/components/elements/LinkWithQuery';
import { getLocaleFromPath } from '@/helpers/getLocaleFromPath';
import { DEFAULT_LOCALE } from '@/constants';
import LogoIcon from '@/public/icons/logo.svg';
import styles from './Center.module.scss';

// Types
interface IProps {
	title?: string;
	showCenterLogo?: boolean;
}

// Animation
const centerMotion = {
	initial: 'initial',
	animate: 'animate',
	exit: 'exit',
	variants: {
		initial: {
			y: '-10%',
			opacity: 0,
		},
		animate: {
			y: 0,
			opacity: 1,
		},
		exit: {
			y: '-10%',
			opacity: 0,
		},
	},
	transition: {
		type: 'spring',
		duration: 0.5,
	},
};

export const Center = React.forwardRef(
	(
		{ title, showCenterLogo }: IProps,
		ref: React.ForwardedRef<HTMLDivElement>,
	) => {
		const router = useRouter();
		const pathForLocale = router.asPath?.split('?')[0] || '/';
		const locale = getLocaleFromPath(pathForLocale);
		const homeHref = locale === DEFAULT_LOCALE ? '/' : `/${locale}`;
		return (
			<motion.div
				ref={ref}
				className={styles['header']}
				// Animation
				{...centerMotion}
			>
				{showCenterLogo ? (
					<LinkWithQuery
						href={homeHref}
						className={styles['header__logo']}
						preserveQuery={false}
					>
						<LogoIcon className={`${styles['header__icon']}`} />
					</LinkWithQuery>
				) : null}

				{!showCenterLogo && title ? (
					<span className={styles['header__title']}>{title}</span>
				) : null}
			</motion.div>
		);
	},
);
